// extracted by mini-css-extract-plugin
module.exports = {"container":"fallback-error_container__2t4te","textContainer":"fallback-error_textContainer__17V6B","link":"fallback-error_link__3vySX","span":"fallback-error_span__3L6id"};